import {Button, Typography} from '@mui/material';
import {useAuth} from '@saltus/auth';
import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import MfaEnrolmentPanel from '../../components/Mfa/MfaEnrolmentPanel';
import Theme, {themeColors} from '../../theme/Theme';

const classes = {
  button: {
    backgroundColor: themeColors.coral,
    border: `2px solid ${themeColors.coral}`,
    color: themeColors.white,
    fontWeight: 400,
    margin: 0,
    padding: '5px 60px',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: themeColors.backgroundDark,
      border: `2px solid ${themeColors.backgroundDark}`,
    },
  },

  infoText: {
    color: themeColors.tan,
    fontWeight: 600,
    margin: `${Theme.spacing(2)} 0`,
  },
};

function MfaEnrolmentSmsPage() {
  const {getUserAttributeVerificationCode, getUserDetails, updateUser, user} = useAuth();
  const navigate = useNavigate();
  const [mobile, setMobile] = useState<string | null>(null);

  useEffect(() => {
    getUserDetails<{
      mobile: string;
    }>().then((details) => {
      if (details) {
        setMobile(details.mobile);
      }
    });
  }, [getUserDetails]);

  return (
    <MfaEnrolmentPanel
      title="Two-factor authentication"
      subTitle="Text message"
      backTo="/2fa-enrolment"
      button={
        <Button
          sx={classes.button}
          type="button"
          variant="outlined"
          onClick={() => {
            if (mobile) {
              updateUser({
                phone_number: mobile,
              })
                .then(() => getUserAttributeVerificationCode('phone_number'))
                .then(() => {
                  navigate('/2fa-enrolment/code/sms/');
                });
            }
          }}
        >
          Continue
        </Button>
      }
      align="left"
    >
      {user && mobile && (
        <>
          <Typography variant="body1">
            We&apos;ll text a verification code to this mobile number whenever you sign
            into your account.
          </Typography>

          <Typography sx={classes.infoText} variant="body2">
            {mobile}
          </Typography>

          <Typography variant="body1">
            If the mobile number is incorrect please contact our Platform Services team on
            01489 663700.
          </Typography>
        </>
      )}
    </MfaEnrolmentPanel>
  );
}

export default MfaEnrolmentSmsPage;
